import React from 'react'
import { SearchX } from 'lucide-react'
import { Button } from 'components/ui/button'

interface NoteSearchEmptyProps {
	query: string
	onClear: () => void
	/** What is being searched, e.g. 'notes' or 'location notes'. */
	label?: string
}

/**
 * Shown when a search matches nothing.
 *
 * Deliberately distinct from the "No Notes Yet" empty state: that one invites
 * writing the first note, which is the wrong prompt when notes exist and the
 * query simply excluded them all.
 */
const NoteSearchEmpty: React.FC<NoteSearchEmptyProps> = ({ query, onClear, label = 'notes' }) => (
	<div className="flex flex-col items-center rounded-lg border border-border bg-white px-6 py-10 text-center">
		<div className="mb-3 flex h-10 w-10 items-center justify-center rounded-lg bg-muted text-muted-foreground">
			<SearchX className="h-5 w-5" />
		</div>
		<p className="m-0 text-sm text-foreground">
			No {label} match <span className="font-semibold">“{query}”</span>
		</p>
		<p className="mb-4 mt-1 text-xs text-muted-foreground">
			Search looks at note text and image descriptions.
		</p>
		<Button type="button" variant="ghost" onClick={onClear}>
			Clear search
		</Button>
	</div>
)

export default NoteSearchEmpty
